import StoreVuexModule from '@/stores/StoreVuexModule';
import store from '@/store';
import Axios from 'axios';
import { getModule } from 'vuex-module-decorators';
import { v4 as uuidv4 } from 'uuid';

export default class LoginService {
    private appStore: StoreVuexModule;

    public constructor() {
        this.appStore = getModule(StoreVuexModule, store);
    }

    public async recaptchaLogin(recaptchaToken: string) {
        let userIdentifier = ''; // sessionStorage.getItem('mat-selector-widget:user-id');
        if (!userIdentifier) {
            userIdentifier = uuidv4();
            // sessionStorage.setItem('mat-selector-widget:user-id', userIdentifier);
        }

        const result = await Axios.post<string>('/Auth/RecaptchaLogin', { userIdentifier }, {
            baseURL: this.appStore.baseApiUrl,
            headers: {
                'x-ApiKey': this.appStore.apiKey,
                'x-RecaptchaToken': recaptchaToken,
            },
        });

        if (result.status === 200) {
            return result.data;
        } else {
            return '';
        }
    }
}
